module.exports = __webpack_public_path__ + "static/media/awarded.e3b50f30.png";